export default [
  //#region RADICAR NUEVA QUEJA
  {
    path: "complaints-emisor/confirm",
    component: () => import("@/views/dashboard/complaints-emisor/Confirm.vue"),
    meta: {
      title: "Radicar nueva inconformidad contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Radicar nueva inconformidad contra un emisor de valores",
          link: "/dashboard/complaints-emisor/",
        },
      ],
    },
  },
  {
    path: "complaints-emisor/management",
    component: () =>
      import(
        "@/feature/dashboard/complaints_emisor/presentation/views/management.vue"
      ),
    meta: {
      title: "Quejas contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Quejas contra un emisor de valores",
          link: "/dashboard/complaints-emisor/management",
        },
      ],
    },
  },
    {
    path: "complaints-emisor/detail/:id",     
    name: "complaints-emisor-detail",
    component: () =>
      import("@/feature/dashboard/complaints_emisor/presentation/views/detail.vue"),
    meta: {
      title: "Quejas contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        { label: "Quejas contra un emisor de valores", link: "/dashboard/complaints-emisor/management" },
        {
          label: "Detalle"           
        },
      ],
    },
  },
  {
    path: "complaints-emisor/new",
    component: () =>
      import("@/views/dashboard/complaints-emisor/NewComplaintEmisor.vue"),
    meta: {
      title: "Radicar una nueva inconformidad contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Radicar nueva inconformidad contra un emisor de valores",
          link: "/dashboard/complaints-emisor/new",
        },
      ],
    },
  },
  {
    path: "complaints-emisor/new/registeredcustomer",
    name: "ComplaintsEmisorNewRegisteredCustomer",
    component: () =>
      import("@/views/dashboard/complaints-emisor/RegisteredCustomer.vue"),
    meta: {
      title: "Radicar una nueva inconformidad contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Radicar nueva inconformidad contra un emisor de valores",
          link: "/dashboard/complaints-emisor/new",
        },
        {
          label:
            "Radicar nueva inconformidad contra un emisor de valores con una persona registrada",
        },
      ],
    },
  },
  {
    name: "ComplaintEmisorRegistration",
    path: "complaints-emisor/create",
    props: true,
    component: () =>
      import(
        "@/views/dashboard/complaints-emisor/ComplaintEmisorRegistration.vue"
      ),
    meta: {
      title: "Radicar una nueva inconformidad contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Radicar nueva inconformidad contra un emisor de valores",
          link: "/dashboard/complaints-emisor/new",
        },
        { label: "Formulario nueva inconformidad contra un emisor de valores" },
      ],
    },
  },
  {
    path: "complaints-emisor/new/customerregistration",
    name: "ComplaintsEmisorNewCustomerRegistration",
    component: () =>
      import("@/views/dashboard/complaints-emisor/CustomerRegistration.vue"),
    meta: {
      title: "Radicar una nueva inconformidad contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Radicar nueva inconformidad contra un emisor de valores",
          link: "/dashboard/complaints-emisor/new",
        },
        {
          label:
            "Radicar nueva inconformidad contra un emisor de valores con una persona sin registrar",
        },
      ],
    },
  },
  {
    path: "complaint-emisor/new/completed",
    name: "RegisteredComplaintEmisorAdmin",
    props: true,
    component: () =>
      import("@/views/shared/RegisteredComplaintEmisor.vue"),
    meta: {
      title: "Radicar una nueva inconformidad contra un emisor de valores",
      breadcrumb: [
        { label: "Inicio", link: "/" },        
              {
          label: "Radicar nueva inconformidad contra un emisor de valores",
          link: "/dashboard/complaints-emisor/new",
        }, 
        { label: "Código de registro" },
      ],
    },
  },

  {
    name: "ComplaintRegistration",
    path: "complaint/create",
    props: true,
    component: () =>
      import("@/views/dashboard/complaints/ComplaintRegistration.vue"),
    meta: {
      title: "Radicar una nueva inconformidad",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Radicar nueva inconformidad",
          link: "/dashboard/complaints/",
        },
        { label: "Formulario nueva inconformidad" },
      ],
    },
  },
  //#endregion
];
